import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import Images from "../../Images";
import { Col, Container, Dropdown, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GoPlus } from "react-icons/go";
import { FiUpload } from "react-icons/fi";
import Scorecard from "../../Modal/Scorecard";
import { getListingsAxios } from "../../Actions/v1/admin";
import { useSelector } from "react-redux";
import {
  addEditFormLists,
  EditFormLists,
  getCategory,
  getNetwork,
  sendOtpforEmail,
} from "../../Actions/v1/user";
import { toast } from "react-toastify";
import {
  calculateCompletionPercentage,
  formatDateMonYr,
  getAddItemFieldMap,
  isEmpty,
} from "../../Actions/commonFunction";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import OTPInput from "react-otp-input";
import Vacnewcoin from "../Vacnewcoin";

function Listcointoken() {
  const navigate = useNavigate();
  const { account } = useSelector((state) => state?.user);
  console.log("account", account);
  const location = useLocation();
  console.log("EEFEFEF", location);
  const formRecords = location?.state;
  const [otp, setOtp] = useState("");
  const [exchangeLists, setExchangeLists] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [filterRows, setFilterRows] = useState([{ filters: "" }]);
  const [steps, setSteps] = useState(1);
  const [formsLists, setFormsLists] = useState({
    userId: "",
    email: "",
    projectSubcheckOne: false,
    projectSubchecktwo: false,
    suggesstion: "",
    Fields: {},
  });
  console.log("🚀 ~ Listcointoken ~ formsLists:", formsLists);
  const [formErrors, setFormErrors] = useState({});
  console.log("exchangeListsexchangeLists", exchangeLists, startDate);
  const [legal, setLegal] = useState(false);
  console.log("legal", steps, exchangeLists.length);
  const [err, setErr] = useState({});

  const [projectype, setProjectype] = useState("");
  const [stepname, setStepname] = useState("");
  console.log("werrrrrrr", stepname);
  const [emailOtp, setEmailOtp] = useState("");
  const [verifyOtp, setVerifyOtp] = useState({});
  const [verified, setVerified] = useState(false);
  const [otpSend, setOtpSend] = useState(false);

  const [loader, setLoader] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    email: "",
    legal: "",
    projectType: "",
    projectSubcheckOne: "",
    projectSubchecktwo: "",
    suggesstion: "",
  });

  const [selCat, setSelCat] = useState("");
  const [selNetwork, setSelNetwork] = useState("");
  const [subCat, setSubCat] = useState([]);
  const [selSubCat, setSelSubCat] = useState("");
  const [categorylist, setCategorylist] = useState([]);
  const [networklist, setNetworkList] = useState([]);

  let initialData = {
    projectName: "",
    logo: "",
    symbol: "",
    TotalSupply: "",
    MaxSupply: "",
    CirculatingSupply: "",
    mailId: "",
    category: "",
    subcategory: "",
    network: "",
    pairAddress: "",
    shortdescription: "",
    blockExplorer: "",
    whitpaperlink: "",
    git_link: "",
    Twitterlink: "",
  };

  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    if (formRecords) {
      setFormsLists({
        userId: formRecords?.records?.userId,
        email: formRecords?.records?.email,
        projectSubcheckOne: formRecords?.records?.projectSubcheckOne || false,
        projectSubchecktwo: formRecords?.records?.projectSubchecktwo || false,
        suggesstion: formRecords?.records?.suggesstion || "",
        Fields: formRecords?.records?.fields,
      });
      setSteps(formRecords?.step);
      setProjectype(formRecords?.records?.projectType || true);
      setLegal(true);
      setVerified(true);
    }
  }, [formRecords]);
  console.log("fieldErrors", fieldErrors);
  const [percentage, setPercentage] = useState(0);
  const getExchangeList = async () => {
    let resp = await getListingsAxios({ section: "coin" });
    console.log("🚀 ~ setExchangeLists ~ resp:", resp);
    if (resp?.status) {
      setExchangeLists(resp?.data?.data);
    }
  };
  console.log("projectype", projectype);
  const projectTypeOptions = [
    { label: "Centralized", value: "centralized" },
    { label: "Decentralized", value: "decentralized" },
  ];
  const validateFormForStep = (stepName, data) => {
    const errors = {};
    const stepData = exchangeLists?.find((s) => s?.stepName === stepName);
    const fields = data
      ? data?.Fields?.[stepName]
      : formsLists?.Fields?.[stepName] || {};
    console.log("fieldsfieldsfields", fields, formsLists, stepData, stepName);

    if (!stepData?.inputs) return errors;
    const isFieldEmpty = (fieldValue) => {
      console.log("fieldValuefieldValue", fieldValue);
      return (
        fieldValue === undefined ||
        fieldValue === null ||
        (Array.isArray(fieldValue) &&
          (fieldValue?.length === 0 ||
            fieldValue.includes("") ||
            fieldValue.every(
              (el) => el.trim?.() === "" || el.trim?.() === ""
            ))) ||
        (typeof fieldValue === "string" && fieldValue.trim() === "")
      );
    };
    stepData?.inputs?.forEach((input) => {
      if (input?.type === "MultiQuestion" && Array.isArray(input?.subinputs)) {
        const multiFieldArray = fields[input?.subheading];
        console.log("firstttttnamees", multiFieldArray);

        if (Array.isArray(multiFieldArray)) {
          multiFieldArray?.forEach((item, index) => {
            console.log("eeeeeee", input);

            input?.subinputs?.forEach((sub) => {
              if (sub.required || input.required) {
                const value = item?.[sub.name];
                if (isFieldEmpty(value)) {
                  if (!errors[input.subheading]) errors[input.subheading] = {};
                  if (!errors[input.subheading][index])
                    errors[input.subheading][index] = {};
                  errors[input.subheading][index][
                    sub.name
                  ] = `${sub.name} is required.`;
                }
              }
            });
          });
        }
      } else if (input?.type === "Shortanswer" && input?.otpcheck) {
        console.log(
          "iiiiiiiii",
          !otp?.[stepName]?.[input.name]?.checked,
          !otp?.[stepData?.stepName]?.[input?.name],
          !otp?.[stepData?.stepName]?.[input?.name] &&
            !otp?.[stepName]?.[input.name]?.checked
        );
        if (!otp?.[stepName]?.[input.name]?.checked) {
          errors[input.name] = `${input.name} is required`;
        }
      } else {
        if (input?.required) {
          const fieldValue = formsLists?.Fields?.[stepName]?.[input.name];
          console.log("fieldValue", fieldValue);

          if (isFieldEmpty(fieldValue)) {
            console.log("e4w33333333333333333333333333");

            errors[input.name] = `${input.name} is required`;
          }
        }
      }
    });

    return errors;
  };

  const handleAddShortAnswer = (
    stepName,
    fieldId,
    type = "",
    subinputs = []
  ) => {
    console.log("44444444444", stepName, fieldId);
    if (type === "multiquestion") {
      setFormsLists((prev) => {
        const prevBlocks = prev?.Fields?.[stepName]?.[fieldId] || [];

        const newBlock = { subheading: fieldId };
        subinputs.forEach((input) => {
          newBlock[input.name] = "";
        });

        const updatedBlocks = [...prevBlocks, newBlock];

        return {
          ...prev,
          Fields: {
            ...prev.Fields,
            [stepName]: {
              ...(prev.Fields?.[stepName] || {}),
              [fieldId]: updatedBlocks,
            },
          },
        };
      });
    } else {
      setFormsLists((prev) => {
        return {
          ...prev,
          Fields: {
            ...prev.Fields,
            [stepName]: {
              ...(prev.Fields?.[stepName] || {}),
              [fieldId]: [...(prev.Fields?.[stepName]?.[fieldId] || []), ""],
            },
          },
        };
      });
    }
  };
  console.log("listing_forms_data", formsLists);

  const handleShortAnswerChange = (
    stepName,
    fieldId,
    index,
    value,
    type = ""
  ) => {
    console.log("stepFieldIndex", stepName, fieldId, index, value);
    if (type == "otp") {
      setEmailOtp(value);
    }
    clearFieldError(stepName, fieldId);
    setFormsLists((prev) => {
      const updatedAnswers = [...(prev.Fields?.[stepName]?.[fieldId] || [])];
      updatedAnswers[index] = value;

      return {
        ...prev,
        Fields: {
          ...prev.Fields,
          [stepName]: {
            ...(prev.Fields?.[stepName] || {}),
            [fieldId]: updatedAnswers ? updatedAnswers : [""],
          },
        },
      };
    });
  };

  const handleRemoveShortAnswer = (
    stepName,
    fieldId,
    indexToRemove,
    type = ""
  ) => {
    if (type == "mutilquestion") {
      setFormsLists((prev) => {
        const updatedBlocks = [...(prev?.Fields?.[stepName]?.[fieldId] || [])];
        updatedBlocks.splice(indexToRemove, 1);

        return {
          ...prev,
          Fields: {
            ...prev.Fields,
            [stepName]: {
              ...(prev.Fields?.[stepName] || {}),
              [fieldId]: updatedBlocks,
            },
          },
        };
      });
    } else {
      setFormsLists((prev) => {
        const updatedAnswers = [...(prev.Fields?.[stepName]?.[fieldId] || [])];
        updatedAnswers.splice(indexToRemove, 1);

        return {
          ...prev,
          Fields: {
            ...prev.Fields,
            [stepName]: {
              ...(prev.Fields?.[stepName] || {}),
              [fieldId]: updatedAnswers,
            },
          },
        };
      });
    }
  };

  //Get Category
  const getCategorylist = async () => {
    let resp = await getCategory();
    if (resp?.status) {
      setCategorylist(resp.data);
    }
  };

  const getNetworklist = async () => {
    let resp = await getNetwork();
    if (resp?.status) {
      setNetworkList(resp.data);
    }
  };

  useEffect(() => {
    getNetworklist();
    getCategorylist();
    // console.log("coinDetail-->", coinDetail);
    // if (!isEmpty(coinDetail)) {
    //   setFormData({
    //     ...formData,
    //     projectName: coinDetail?.name,
    //     symbol: coinDetail?.symbol,
    //     tokenDecimal: coinDetail?.decimal,
    //     network: coinDetail?.value,
    //     tokenaddress: coinDetail?.tokenAddress,
    //   });
    //   setSelNetwork(coinDetail?.data);
    // }
  }, []);
  const clearFieldError = (stepKey, fieldName) => {
    console.log("errorororoororor", stepKey, fieldName);
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (updatedErrors[stepKey]) {
        updatedErrors[stepKey] = { ...updatedErrors[stepKey] };
        delete updatedErrors[stepKey][fieldName];
        if (Object.keys(updatedErrors[stepKey]).length === 0) {
          delete updatedErrors[stepKey];
        }
      }
      return updatedErrors;
    });
  };

  const handleNextBtton = async (step) => {
    if (step == exchangeLists?.length + 5) {
      let err = await validation();
      if (Object.keys(err)?.length > 0) {
        console.log("error", err);
        return;
      } else {
        setFormsLists((prev) => ({
        ...prev,
        Fields: {
          ...prev.Fields,
          ["Summary Details"]: formData,
        },
      }));
        setSteps(step);
      }
    } else {
      const ErrorsValues = {
        email: "",
        legal: "",
        projectType: "",
        projectSubcheckOne: "",
        projectSubchecktwo: "",
        suggesstion: "",
      };

      let hasError = false;
      let firstErrorToastShown = false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (exchangeLists?.[steps - 2]) {
        if (isEmpty(formsLists?.email)) {
          ErrorsValues.email = "Email is required.";
          firstErrorToastShown = true;
          hasError = true;
        } else if (!emailRegex.test(formsLists?.email)) {
          ErrorsValues.email = "Please enter a valid email.";
          firstErrorToastShown = true;
          hasError = true;
        }

        // if (isEmpty(projectype)) {
        //   ErrorsValues.projectType = "Project Type is required.";
        //   firstErrorToastShown = true;
        //   hasError = true;
        // }
      }
      if (exchangeLists?.[steps - 3] && !legal) {
        ErrorsValues.legal = "Please accept legal requirements.";
        firstErrorToastShown = true;
        hasError = true;
      }

      setFieldErrors(ErrorsValues);
      if (hasError) return;

      const currentStepName = exchangeLists?.[steps - 4]?.stepName;
      const stepData = exchangeLists?.find(
        (s) => s?.stepName === currentStepName
      );
      const stepName = currentStepName;
      console.log("stepName", stepName);

      const updatedFields = { ...(formsLists?.Fields?.[stepName] || {}) };
      const fieldValues = formsLists?.Fields?.[currentStepName] || {};
      stepData?.inputs?.forEach((input) => {
        const fieldName =
          input?.type === "MultiQuestion" ? input?.subheading : input?.name;
        console.log(
          "updatedFields111222",
          input,
          updatedFields,
          input.type === "MultiQuestion"
        );
        console.log("second else");
        if (updatedFields[fieldName] === undefined) {
          if (input.type === "Shortanswer" && !input?.otpcheck) {
            updatedFields[fieldName] = [""];
          } else if (input.type === "Checkbox") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Radio") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Upload") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Dropdown") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Paragraph") {
            updatedFields[fieldName] = "";
          } else if (input.type == "MultiQuestion") {
            console.log("eeeeefttttttttttttttttt", updatedFields);
            updatedFields[fieldName] = [{}];
            console.log(
              "eeeeefttttttttttttttttt_123",
              updatedFields,
              input.subinputs
            );

            input?.subinputs?.map((subInput) => {
              const subfieldName = subInput.name;
              console.log(
                "updatedFields[fieldName]",
                updatedFields,
                updatedFields[fieldName],
                subfieldName
              );

              // if (!updatedFields[fieldName][0][subfieldName]) {
              updatedFields[fieldName][0][subfieldName] = "";
              // }
            });
          } else {
            updatedFields[fieldName] = "";
          }
        }
        // }
      });

      setFormsLists((prev) => ({
        ...prev,
        Fields: {
          ...prev.Fields,
          [stepName]: updatedFields,
        },
      }));

      let data = {
        ...formsLists,
        Fields: {
          ...formsLists.Fields,
          [stepName]: updatedFields,
        },
      };
      console.log("444fffffffff", currentStepName, updatedFields);

      const errors = validateFormForStep(currentStepName, data);
      console.log("uiyuuuuuu", errors);
      if (Object.keys(errors).length > 0) {
        setFormErrors({ [currentStepName]: errors });
        return;
      }
      setFormErrors({});
      setSteps(step);
    }

    console.log("stepstepstepstepstep", step);
  };

  const handleSubmit = async (steps) => {
    console.log("stepsstepsstepssteps", steps);

    try {
      const ErrorsValues = {
        email: "",
        legal: "",
        projectType: "",
        projectSubcheckOne: "",
        projectSubchecktwo: "",
        suggesstion: "",
      };
      let hasError = false;
      let firstErrorToastShown = false;
      if (!formsLists?.projectSubcheckOne) {
        ErrorsValues.projectSubcheckOne = "check box is required.";
        if (!firstErrorToastShown) {
          // toast.error(ErrorsValues.projectSubcheckOne);
          firstErrorToastShown = true;
        }
        hasError = true;
      }

      if (!formsLists?.projectSubchecktwo) {
        ErrorsValues.projectSubchecktwo = "check box is required.";
        if (!firstErrorToastShown) {
          // toast.error(ErrorsValues.projectSubchecktwo);
          firstErrorToastShown = true;
        }
        hasError = true;
      }
      if (isEmpty(formsLists?.suggesstion)) {
        ErrorsValues.suggesstion = "suggesstion is required.";
        if (!firstErrorToastShown) {
          // toast.error(ErrorsValues.suggesstion);
          firstErrorToastShown = true;
        }
        hasError = true;
      }
      setFieldErrors(ErrorsValues);
      console.log("gggggggggg", ErrorsValues);
      if (hasError) return;

      const currentStepName = exchangeLists?.[steps - 4]?.stepName;
      console.log("currentStepNamecurrentStepName", currentStepName);
      const stepData = exchangeLists?.find(
        (s) => s.stepName === currentStepName
      );
      console.log("tttttttttt", stepData);

      const stepName = currentStepName;

      const updatedFields = { ...(formsLists?.Fields?.[stepName] || {}) };
      console.log("updatedFields", updatedFields);

      stepData?.inputs?.forEach((input) => {
        const fieldName =
          input.type === "MultiQuestion" ? input.subheading : input.name;
        if (updatedFields[fieldName] === undefined) {
          if (input.type === "Shortanswer") {
            updatedFields[fieldName] = [""];
          } else if (input.type === "Checkbox") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Radio") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Upload") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Dropdown") {
            updatedFields[fieldName] = "";
          } else if (input.type === "Paragraph") {
            updatedFields[fieldName] = "";
          } else if (input.type == "MultiQuestion") {
            console.log("eeeeefttttttttttttttttt", updatedFields);
            updatedFields[fieldName] = [{}];
            console.log(
              "eeeeefttttttttttttttttt_123",
              updatedFields,
              input.subinputs
            );

            input?.subinputs?.map((subInput) => {
              const subfieldName = subInput.name;
              console.log(
                "updatedFields[fieldName]",
                updatedFields,
                updatedFields[fieldName],
                subfieldName
              );

              // if (!updatedFields[fieldName][0][subfieldName]) {
              updatedFields[fieldName][0][subfieldName] = "";
              // }
            });
          } else {
            updatedFields[fieldName] = "";
          }
        }
      });
      const fullFormDetails = {
        ...formsLists?.Fields,
        [currentStepName]: updatedFields,
      };
      let data = {
        ...formsLists,
        Fields: {
          ...formsLists.Fields,
          [stepName]: updatedFields,
        },
      };
      console.log("data", data);
      const errors = validateFormForStep(currentStepName, data);

      if (Object.keys(errors)?.length > 0) {
        console.log("Validation Errors:", errors);
        setFormErrors({ [currentStepName]: errors });
        return;
      }
      delete fullFormDetails["undefined"];
      setFormsLists((prev) => ({
        ...prev,
        Fields: fullFormDetails,
      }));
      // const fullFormDetails = formsLists?.Fields;
      setFormErrors({});
      // setSteps(steps)
      console.log("Submitting full form", fullFormDetails, {
        ...fullFormDetails,
        userId: account?._id,
        email: formsLists?.email,
        section: "coin",
        projectType: projectype,
        projectSubcheckOne: formsLists?.projectSubcheckOne,
        projectSubchecktwo: formsLists?.projectSubchecktwo,
        suggesstion: formsLists?.suggesstion,
      });
      let resp;
      if (formRecords && formRecords?.action == "edit") {
        resp = await EditFormLists({
          ...fullFormDetails,
          userId: account?._id,
          email: formsLists?.email,
          section: "coin",
          status: "pending",
          projectType: projectype,
          projectSubcheckOne: formsLists?.projectSubcheckOne,
          projectSubchecktwo: formsLists?.projectSubchecktwo,
          suggesstion: formsLists?.suggesstion,
          _id: formRecords?.records?._id,
        });
      } else {
        resp = await addEditFormLists({
          ...fullFormDetails,
          userId: account?._id,
          email: formsLists?.email,
          section: "coin",
          status: "pending",
          projectType: projectype,
          projectSubcheckOne: formsLists?.projectSubcheckOne,
          projectSubchecktwo: formsLists?.projectSubchecktwo,
          suggesstion: formsLists?.suggesstion,
        });
      }
      console.log("response", resp);
      if (resp?.status) {
        navigate("/scorecardcointoken", {
          state: { ans: resp?.data?.data, ques: exchangeLists },
        });
        toast.success(resp?.message);
      } else {
        toast.error("Oops something went wrong.");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  console.log("formsLists", formsLists, exchangeLists, stepname);

  const sendOtp = async (emailId = "", OtpType, stepName, name) => {
    console.log("sendOtp", emailOtp, OtpType, stepName, name);

    try {
      if (loader) {
        return toast.error("Please wait, OTP is being sent.");
      }
      setLoader(true);

      if (OtpType == "mail") {
        let emailID = emailOtp ? emailOtp : emailId;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailID) {
          return toast.error("Email Id is required.");
        } else if (!emailRegex.test(emailID)) {
          return toast.error("Please enter valid email Id.");
        }
        setVerified(false);
        // setOtp("")
      }
      if (OtpType == "mobile") {
        // let emailID = emailOtp ? emailOtp : emailId;
        // const mobileRegex = /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm;
        // if (!emailID) {
        //   return toast.error("Email Id is required.")
        // }
        // else if (!mobileRegex.test(emailID)) {
        //   return toast.error("Please enter valid email Id.")
        // }
        setVerified(false);
        // setOtp("")
      }

      const toastId = toast.loading("Sending OTP...");
      const resp = await sendOtpforEmail({
        email: emailOtp ? emailOtp : emailId,
      });
      console.log("rerororoop", resp);
      if (resp.status) {
        setVerifyOtp((prev) => ({
          [stepName]: {
            ...prev?.[stepName],
            [name]: resp?.data,
          },
        }));
        // !(otp?.[stepData?.stepName]?.[input?.name])
        setOtpSend(true);
        toast.success(resp.message || "OTP sent successfully", {
          id: toastId,
          duration: 3000,
        });
        toast.dismiss(toastId);
      } else {
        toast.error(resp?.message || "Failed to send OTP", {
          id: toastId,
          duration: 3000,
        });
        toast.dismiss(toastId);
      }

      setLoader(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const otpVerifySubmit = async ({ stepName, question }) => {
    try {
      console.log("dddddddddddd", otp, verifyOtp);
      if (verifyOtp && !otp?.[stepName]?.[question]?.otp) {
        toast.error("OTP is required.");
      } else if (
        verifyOtp?.[stepName]?.[question] == otp?.[stepName]?.[question]?.otp
      ) {
        toast.success("OTP verified successfully");
        // setVerified({otp?.[stepName]?.[question]?.otp})
        setOtp({
          ...otp,
          [stepName]: {
            ...otp?.[stepName],
            [question]: {
              otp: otp?.[stepName]?.[question]?.otp,
              checked: otp?.[stepName]?.[question]?.checked
                ? otp?.[stepName]?.[question]?.checked
                : true,
            },
          },
        });
        setOtpSend(false);
      } else {
        toast.error("OTP is incorrect.");
        setVerified(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSendOtp = async (e, data) => {
    console.log("ffffghgggg", e, data);

    setOtp({
      ...otp,
      [e.stepName]: {
        ...otp?.[e.stepName],
        [e.question]: {
          otp:
            //  otp?.[e.stepName]?.[e.question]?.otp ? otp?.[e.stepName]?.[e.question]?.otp+e.value :
            e.value,
          checked: otp?.[e.stepName]?.[e.question]?.checked
            ? otp?.[e.stepName]?.[e.question]?.checked
            : false,
        },
      },
    });

    // if(data == "mail"){
    //   setOtp(e)
    // }
    // if(data == "mobile"){
    //   setMobileOtp(e)
    // }
  };

  useEffect(() => {
    getExchangeList();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [steps]);

  useEffect(() => {
    const { totalFields, totalPoints, percentageValue } =
      calculateCompletionPercentage(formsLists?.Fields);
    setPercentage(percentageValue);
  }, [formsLists?.Fields]);

  const onchangeFunc = (e) => {
    const { value, name, data } = e.target;
    console.log("e.target-->", e.target);
    setFormData({
      ...formData,
      [name]: value,
      ...(name == "category" ? { subcategory: "" , categoryName : data } : {}),
      ...(name == "subcategory" ? { subcategoryName: data } : {}),
      ...(name == "network" ? { networkName: data } : {}),
    });
    if (name == "category") {
      setSelCat(data);
      setSelSubCat("");
    }
    if (name == "network") {
      setSelNetwork(data);
    }
    if (name == "subcategory") {
      setSelSubCat(data);
    }
  };

  const validation = async () => {
    let error = {};
    console.log("formData-->", formData);
    await Promise.all(
      Object.keys(formData)?.map((val) => {
        if (isEmpty(formData[val])) {
          error[val] = `${val} is required`;
        }
      })
    );
    setErr(error);
    return error;
  };

  return (
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative pb-5">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5">
            <div className="vac_border position-relative vac_system rounded-3 py-5 px-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={8} xxl={9} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />

                  <div className="vac_border rounded-4 py-5 px-4">
                    {steps == 1 && (
                      <>
                        <h4 className="fw-600 text-center">
                          List Your Coin/Token
                        </h4>
                        <p className="text-center">
                          When a user clicks on “List Your Coin/Token,” a page
                          will open with the following information:
                        </p>

                        <div className="pt-3">
                          <p>
                            EdaFace helps crypto lovers to identify and prevent
                            scams. As such, any Project that must be listed on
                            EdaFace Listing Platforms must pass through the
                            Verification Asset Centre (VAC).
                          </p>

                          <p>
                            The VAC asses each Crypto Project using EdaFace{" "}
                            <span className="fw-600">
                              SOC 4-Year Scorecard.
                            </span>{" "}
                          </p>

                          <p>
                            The SOC Scorecard consists of fifteen items, each
                            item having 2 or more evaluative features. For more
                            on VAC, click here…{" "}
                            <Link to="/" target="_blank">
                              <span className="fw-600 text-underline">
                                (https://vac.edaface.com)
                              </span>
                            </Link>
                            .
                          </p>

                          <p>
                            If you are ready to List on EdaFace Listing
                            Platforms and expose your Project to thousands of
                            users, click this button:
                          </p>
                        </div>

                        <div className="text-center pt-3">
                          <button
                            className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                            onClick={() => handleNextBtton(steps + 1)}
                          >
                            Submit Project
                          </button>
                        </div>
                      </>
                    )}
                    {steps == 2 && (
                      <>
                        <h4 className="fw-600 text-center">
                          General Information
                        </h4>
                        <p className="text-center">
                          Fields marked with an asterisk{" "}
                          <span className="redclr">(*)</span> are required.
                        </p>

                        <div className="form_list">
                          <div className="mb-3">
                            <label>
                              Company’s Email address
                              <span className="redclr">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              id="email"
                              value={formsLists.email}
                              placeholder="Email"
                              onChange={(e) => {
                                setFormsLists({
                                  ...formsLists,
                                  email: e.target.value,
                                });
                                setFieldErrors((prevErrors) => ({
                                  ...prevErrors,
                                  email: "",
                                }));
                              }}
                            />
                            {fieldErrors.email && (
                              <div className="text-danger mt-2">
                                {fieldErrors.email}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="text-center pt-3">
                          <button
                            className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                            onClick={() => handleNextBtton(steps + 1)}
                          >
                            Next
                          </button>
                        </div>
                      </>
                    )}
                    {steps == 3 && (
                      <>
                        <h4 className="fw-600 text-center">
                          Accepts Legal Requirements
                        </h4>
                        <p className="text-center">
                          Please, review all the legal requirements before you
                          proceed further
                        </p>

                        <div class="form-check d-flex verifycheck">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            checked={legal}
                            id="flexCheckDefault"
                            onClick={(e) => {
                              setLegal(e.target.checked);
                              setFieldErrors((prevErrors) => ({
                                ...prevErrors,
                                legal: "",
                              }));
                            }}
                          />
                          <label
                            class="form-check-label fw-400"
                            for="flexCheckDefault"
                          >
                            I have read and I agree to all the 
                            <Link to="#">Terms of Use</Link>, 
                            <Link to="#">Disclaimers</Link>, 
                            <Link to="#">Listing Terms and Conditions</Link>, 
                            <Link to="#">Privacy Policy</Link>, and all legal
                            requirements of EDA.
                          </label>
                        </div>
                        {fieldErrors.legal && (
                          <div className="text-danger">{fieldErrors.legal}</div>
                        )}

                        <div className="text-center pt-4">
                          <button
                            className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                            onClick={() => handleNextBtton(steps + 1)}
                          >
                            Next
                          </button>
                        </div>
                      </>
                    )}

                    {steps > 3 && steps < 3 + exchangeLists?.length + 1 && (
                      <>
                        <h4 className="fw-600 text-center">
                          Submission Form (Coin or Token)
                        </h4>
                        <p className="text-center mb-2">
                          Please, fill in the details. Note that EdaFace
                          automated system will verify and grade your Project
                          before submission.
                        </p>
                        <div className="mb-4">
                          <p className="fw-600 formtitle text-center mb-1">
                            ITEM {steps - 3}:{" "}
                            {exchangeLists?.[steps - 4]?.stepName}
                          </p>
                          <p className="subtitle text-center mb-0">
                            {exchangeLists?.[steps - 4]?.subtitleHeading}
                          </p>
                        </div>

                        <div className="form_list">
                          {exchangeLists?.[steps - 4]?.inputs?.map((val) => {
                            console.log("valvalvalval", val);

                            if (val?.type == "Calendar") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const value =
                                formsLists?.Fields?.[stepKey]?.[val?.name] ||
                                "";
                              console.log("v23333333alue", value);
                              const error = formErrors?.[stepKey]?.[val?.name];
                              return (
                                <div className="mb-4">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>
                                  <DatePicker
                                    name={val?.name}
                                    id={val?.name}
                                    className="date_input"
                                    showIcon
                                    value={
                                      typeof value == "string"
                                        ? formatDateMonYr(value.split("T")[0])
                                        : value
                                    }
                                    selected={startDate}
                                    onChange={(date) => {
                                      setStartDate(date);
                                      const stepName =
                                        exchangeLists?.[steps - 4]?.stepName;
                                      setFormsLists((prev) => ({
                                        ...prev,
                                        Fields: {
                                          ...prev.Fields,
                                          [stepName]: {
                                            ...(prev.Fields?.[stepName] || {}),
                                            [val?.name]: date ? date : "",
                                          },
                                        },
                                      }));
                                      clearFieldError(stepKey, val.name);
                                    }}
                                  />
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type === "Upload") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const uploadedFile =
                                formsLists?.Fields?.[stepKey]?.[val?.name];
                              const error = formErrors?.[stepKey]?.[val?.name];
                              return (
                                <div className="mb-4">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>
                                  <div className="position-relative pb-3">
                                    <input
                                      type="file"
                                      className="filesets"
                                      id={val?.name}
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;

                                        setFormsLists((prev) => ({
                                          ...prev,
                                          Fields: {
                                            ...prev.Fields,
                                            [stepKey]: {
                                              ...(prev.Fields?.[stepKey] || {}),
                                              [val?.name]: file ? file : "", // store the file object
                                            },
                                          },
                                        }));
                                        clearFieldError(stepKey, val.name);
                                      }}
                                    />
                                    <div className="inputset rounded-1 px-3">
                                      <p className="mb-0">
                                        {typeof uploadedFile == "object"
                                          ? uploadedFile?.name
                                          : (
                                              <img
                                                src={`${config.Back_URL}formImage/${uploadedFile}`}
                                                alt="Uploaded"
                                                style={{
                                                  maxWidth: "15%",
                                                  height: "auto",
                                                  borderRadius: "8px",
                                                }}
                                              />
                                            ) || "Upload Image"}
                                      </p>
                                      <FiUpload fontSize={20} />
                                    </div>
                                  </div>
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type === "MultiQuestion") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const fieldBlocks = formsLists?.Fields?.[
                                stepKey
                              ]?.[val?.subheading] || [""];
                              console.log(
                                "fieldBlocksfieldBlocks",
                                fieldBlocks
                              );
                              return (
                                <div className="mb-4" key={val._id}>
                                  <h5 className="fw-600 mb-3 multimaintxt">
                                    {val?.subheading} {val?.additem ? 1 : ""}{" "}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </h5>

                                  {fieldBlocks.map((block, blockIndex) => {
                                    console.log("reeeeeeee", block, blockIndex);

                                    return (
                                      <div
                                        key={blockIndex}
                                        className="mb-3 position-relative"
                                      >
                                        {blockIndex >= 1 && (
                                          <h5 className="fw-500 mb-3">
                                            {val?.additem
                                              ? `${block?.subheading} ${
                                                  blockIndex + 1
                                                }`
                                              : block?.subheading}
                                          </h5>
                                        )}

                                        {val?.subinputs?.map(
                                          (sub, subIndex) => {
                                            console.log(
                                              "deggggggwwwwwww",
                                              sub,
                                              subIndex
                                            );
                                            const value =
                                              block?.[sub.name] || "";
                                            const error =
                                              formErrors?.[stepKey]?.[
                                                val?.subheading
                                              ]?.[blockIndex]?.[sub.name];
                                            console.log("error", error);
                                            return (
                                              <div
                                                className="mb-2"
                                                key={subIndex}
                                              >
                                                <label className="form-label multilabel">
                                                  {sub?.name}
                                                  {sub?.required && (
                                                    <span className="redclr">
                                                      *
                                                    </span>
                                                  )}
                                                </label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={value}
                                                  onChange={(e) => {
                                                    const inputValue =
                                                      e.target.value;
                                                    setFormsLists((prev) => {
                                                      const updatedBlocks = [
                                                        ...(prev?.Fields?.[
                                                          stepKey
                                                        ]?.[val?.subheading] ||
                                                          []),
                                                      ];
                                                      updatedBlocks[
                                                        blockIndex
                                                      ] = {
                                                        ...updatedBlocks[
                                                          blockIndex
                                                        ],
                                                        [sub.name]: inputValue,
                                                      };
                                                      return {
                                                        ...prev,
                                                        Fields: {
                                                          ...prev.Fields,
                                                          [stepKey]: {
                                                            ...prev.Fields?.[
                                                              stepKey
                                                            ],
                                                            [val?.subheading]:
                                                              updatedBlocks,
                                                          },
                                                        },
                                                      };
                                                    });
                                                    clearFieldError(
                                                      stepKey,
                                                      val?.subheading,
                                                      blockIndex,
                                                      sub.name
                                                    );
                                                  }}
                                                />
                                                {error && (
                                                  <div className="text-danger mt-2">
                                                    {error}
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          }
                                        )}

                                        {fieldBlocks.length > 1 && (
                                          <div className="text-end">
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={() =>
                                                handleRemoveShortAnswer(
                                                  stepKey,
                                                  val?.subheading,
                                                  blockIndex,
                                                  "multiquestion"
                                                )
                                              }
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}

                                  {val?.instruction && (
                                    <p className="mb-2 subtitle">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: val.instruction,
                                        }}
                                      />
                                    </p>
                                  )}

                                  {val?.additem && (
                                    <div className="text-end mt-2">
                                      <button
                                        className="addmore fw-600 py-2 px-2 rounded-2"
                                        onClick={() =>
                                          handleAddShortAnswer(
                                            stepKey,
                                            val?.subheading,
                                            "multiquestion",
                                            val?.subinputs
                                          )
                                        }
                                      >
                                        <GoPlus /> Add more
                                      </button>
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type == "Dropdown") {
                              const stepName =
                                exchangeLists?.[steps - 4]?.stepName;
                              const selectedValue =
                                formsLists?.Fields?.[stepName]?.[val?.name];
                              const error = formErrors?.[stepName]?.[val?.name];
                              return (
                                <div className="mb-4">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>

                                  <Dropdown className="reqdrop">
                                    <Dropdown.Toggle
                                      className="w-100 text-start"
                                      variant="success"
                                    >
                                      {selectedValue || "Select an option"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {val?.options?.map((e, i) => (
                                        <Dropdown.Item
                                          key={i}
                                          onClick={() => {
                                            setFormsLists((prev) => ({
                                              ...prev,
                                              Fields: {
                                                ...prev.Fields,
                                                [stepName]: {
                                                  ...(prev.Fields?.[stepName] ||
                                                    {}),
                                                  [val?.name]: e ? e : "",
                                                },
                                              },
                                            }));
                                            clearFieldError(stepName, val.name);
                                          }}
                                        >
                                          {e}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type === "Shortanswer") {
                              const stepName =
                                exchangeLists?.[steps - 4]?.stepName;
                              const shortAnswers = formsLists?.Fields?.[
                                stepName
                              ]?.[val?.name] || [""];
                              const error = formErrors?.[stepName]?.[val?.name];
                              console.log("shortAnswers", shortAnswers);
                              return (
                                <div className="mb-4">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>
                                  {val?.otpcheck && (
                                    <div className="position-relative">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={
                                          shortAnswers ? shortAnswers?.[0] : ""
                                        }
                                        onChange={(e) =>
                                          handleShortAnswerChange(
                                            stepName,
                                            val.name,
                                            0,
                                            e.target.value,
                                            "otp"
                                          )
                                        }
                                      />
                                      {!shortAnswers ||
                                      !shortAnswers.includes("") ? (
                                        <button
                                          className="themebtn themehoverbtn rounded-1 fbtn widthunset otpbtn py-2 px-3 fw-600"
                                          onClick={(e) =>
                                            sendOtp(
                                              shortAnswers?.[0],
                                              val?.otptype,
                                              stepName,
                                              val?.name
                                            )
                                          }
                                        >
                                          Send OTP
                                        </button>
                                      ) : (
                                        <button
                                          disabled
                                          className="themebtn themehoverbtn rounded-1 fbtn widthunset otpbtn py-2 px-3 fw-600"
                                          onClick={(e) =>
                                            sendOtp(
                                              shortAnswers?.[0],
                                              val?.otptype,
                                              stepName,
                                              val?.name
                                            )
                                          }
                                        >
                                          Send OTP
                                        </button>
                                      )}
                                    </div>
                                  )}
                                  {val?.otpcheck &&
                                    !otp?.[stepName]?.[val?.name]?.checked && (
                                      <div className="my-3 otpsection">
                                        <h5>OTP</h5>
                                        <OTPInput
                                          value={
                                            otp?.[stepName]?.[val?.name]?.otp
                                          }
                                          onChange={(e) =>
                                            handleSendOtp(
                                              {
                                                stepName,
                                                question: val?.name,
                                                value: e,
                                              },
                                              val?.otptype
                                            )
                                          }
                                          numInputs={4}
                                          renderSeparator={<span>-</span>}
                                          renderInput={(props) => (
                                            <input {...props} />
                                          )}
                                        />
                                        <button
                                          className="themebtn themehoverbtn rounded-1 fbtn widthunset mt-2"
                                          onClick={(e) =>
                                            otpVerifySubmit({
                                              stepName,
                                              question: val?.name,
                                            })
                                          }
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    )}
                                  {!val?.otpcheck &&
                                    shortAnswers?.map((answer, index) => (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        <input
                                          type="text"
                                          className={
                                            val?.additem
                                              ? "mb-2 form-control"
                                              : "form-control"
                                          }
                                          placeholder={`Answer ${index + 1}`}
                                          value={answer}
                                          onChange={(e) =>
                                            handleShortAnswerChange(
                                              stepName,
                                              val.name,
                                              index,
                                              e.target.value
                                            )
                                          }
                                        />
                                        {index > 0 && (
                                          <button
                                            // type="button"
                                            className="addmore fw-600 py-2 px-2 rounded-2"
                                            onClick={() =>
                                              handleRemoveShortAnswer(
                                                stepName,
                                                val.name,
                                                index
                                              )
                                            }
                                          >
                                            Remove
                                          </button>
                                        )}
                                      </div>
                                    ))}
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                  {val?.additem && (
                                    <div className="text-end mt-2">
                                      <button
                                        // type="button"
                                        className="addmore fw-600 py-2 px-2 rounded-2"
                                        onClick={() =>
                                          handleAddShortAnswer(
                                            stepName,
                                            val.name
                                          )
                                        }
                                      >
                                        <GoPlus />
                                        Add more
                                      </button>
                                    </div>
                                  )}
                                </div>
                              );
                            }
                            if (val?.type === "Paragraph") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const value =
                                formsLists?.Fields?.[stepKey]?.[val?.name] ||
                                "";
                              const error = formErrors?.[stepKey]?.[val?.name];
                              return (
                                <div className="mb-4">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>

                                  <textarea
                                    className="form-control"
                                    id={val?.name}
                                    value={value}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setFormsLists((prev) => ({
                                        ...prev,
                                        Fields: {
                                          ...prev.Fields,
                                          [stepKey]: {
                                            ...(prev.Fields?.[stepKey] || {}),
                                            [val?.name]: newValue
                                              ? newValue
                                              : "",
                                          },
                                        },
                                      }));
                                      clearFieldError(stepKey, val.name);
                                    }}
                                  />
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type === "Radio") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const selectedValue =
                                formsLists?.Fields?.[stepKey]?.[val?.name];
                              const error = formErrors?.[stepKey]?.[val?.name];
                              return (
                                <div className="mb-4 radiobox">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>
                                  <div className="radioflex">
                                    {val?.options?.map((option, i) => (
                                      <div className="form-check" key={i}>
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={val?.name}
                                          id={`${val?.name}-${i}`} // unique ID for each option
                                          value={option}
                                          checked={selectedValue === option}
                                          onChange={(e) => {
                                            const newValue = e.target.value;
                                            setFormsLists((prev) => ({
                                              ...prev,
                                              Fields: {
                                                ...prev.Fields,
                                                [stepKey]: {
                                                  ...(prev.Fields?.[stepKey] ||
                                                    {}),
                                                  [val?.name]: newValue
                                                    ? newValue
                                                    : "",
                                                },
                                              },
                                            }));
                                            clearFieldError(stepKey, val.name);
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${val?.name}-${i}`}
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }

                            if (val?.type == "Checkbox") {
                              const stepKey =
                                exchangeLists?.[steps - 4]?.stepName;
                              const selectedValue =
                                formsLists?.Fields?.[stepKey]?.[val?.name];
                              const error = formErrors?.[stepKey]?.[val?.name];
                              return (
                                <div className="mb-4 checkbox_wh">
                                  <label>
                                    {val?.name}
                                    {val?.required && (
                                      <span className="redclr">*</span>
                                    )}
                                  </label>
                                  <div>
                                    {val?.options?.map((option, i) => (
                                      <div className="form-check" key={i}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name={val?.name}
                                          id={`${val?.name}-${i}`} // unique ID for each option
                                          value={option}
                                          checked={selectedValue === option}
                                          onChange={(e) => {
                                            const newValue = e.target.value;
                                            setFormsLists((prev) => ({
                                              ...prev,
                                              Fields: {
                                                ...prev.Fields,
                                                [stepKey]: {
                                                  ...(prev.Fields?.[stepKey] ||
                                                    {}),
                                                  [val?.name]: newValue
                                                    ? newValue
                                                    : "",
                                                },
                                              },
                                            }));
                                            clearFieldError(stepKey, val.name);
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${val?.name}-${i}`}
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  {error && (
                                    <div className="text-danger mt-2">
                                      {error}
                                    </div>
                                  )}
                                </div>
                              );
                            }
                          })}
                          <div className="text-center d-flex align-items-center justify-content-between pt-3">
                            <button
                              className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                              onClick={() => setSteps(steps - 1)}
                            >
                              Previous
                            </button>
                            <button
                              className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                              onClick={() => handleNextBtton(steps + 1)}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </>
                    )}

                    {steps == exchangeLists?.length + 4 && (
                      <>
                        <h4 className="fw-600 text-center">
                          New Coin Listing Request Form
                        </h4>
                        <p className="text-center">
                          Submit this form to request the listing of your new
                          coin. If you're looking to update existing coin
                          information, kindly use our dedicated form for updates
                          here.
                        </p>
                        <>
                          <div className="pt-5">
                            <h4 className="fw-600 text-center">
                              {steps - 4}. Summary Details
                            </h4>
                            <Row className="form_list">
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Coin/Token Name{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="projectName"
                                    onChange={onchangeFunc}
                                    value={formData?.projectName}
                                    placeholder="Name of the coin/token, e.g. Bitcoin"
                                  />
                                  <p className="mt-2 mb-0 lightclr">
                                    Kindly adhere to the if your asset falls
                                    under one of the following categories:{" "}
                                  </p>
                                  <p className="mb-0 lightclr">
                                    - Stablecoins, Wrapped Assets, Bridged
                                    Assets, Merged Assets, Tokenized RWA Assets,
                                    Synthetic Assets, Staked Assets/LSTs/LRTs,
                                    and Escrowed Assets
                                  </p>
                                  {err?.projectName && (
                                    <p className="text-danger mt-2">{err?.projectName}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Coin/Token Symbol{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="symbol"
                                    onChange={onchangeFunc}
                                    value={formData?.symbol}
                                    placeholder="Symbol of the coin/token, e.g. BTC"
                                  />
                                  {err?.symbol && <p className="text-danger mt-2">{err?.symbol}</p>}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Token Decimal{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="tokenDecimal"
                                    onChange={onchangeFunc}
                                    value={formData?.tokenDecimal}
                                    placeholder="Decimal of the coin/token, e.g. 18"
                                  />
                                  {err?.tokenDecimal && (
                                    <p className="text-danger mt-2">{err?.tokenDecimal}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Token Contract Address{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="tokenaddress"
                                    onChange={onchangeFunc}
                                    value={formData?.tokenaddress}
                                    placeholder="Decimal of the coin/token, e.g. 18"
                                  />
                                  {err?.tokenaddress && (
                                    <p className="text-danger mt-2">{err?.tokenaddress}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    ProjectRelation{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ProjectRelation"
                                    onChange={onchangeFunc}
                                    value={formData?.ProjectRelation}
                                    placeholder="Project Submiter Relation"
                                  />
                                  <p className="mt-2 mb-0 lightclr">
                                    CEO , EMPLOYEE etc..,
                                  </p>
                                  {err?.ProjectRelation && (
                                    <p className="text-danger mt-2">{err?.ProjectRelation}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Mail Id <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="mailId"
                                    onChange={onchangeFunc}
                                    value={formData?.mailId}
                                    placeholder="Project Submiter Relation"
                                  />
                                  <p className="mt-2 mb-0 lightclr">
                                    Login mail Id
                                  </p>
                                  {err?.mailId && <p className="text-danger mt-2">{err?.mailId}</p>}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Logo(URL) <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="logo"
                                    value={formData?.logo}
                                    onChange={onchangeFunc}
                                    placeholder="URL. Eg:https://cryptologos.cc/logos/bnb-bnb-logo.png"
                                  />
                                  {err?.logo && <p className="text-danger mt-2">{err?.logo}</p>}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    TotalSupply{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="TotalSupply"
                                    value={formData?.TotalSupply}
                                    onChange={onchangeFunc}
                                    placeholder="TotalSupply"
                                  />
                                  {err?.TotalSupply && (
                                    <p className="text-danger mt-2">{err?.TotalSupply}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    MaxSupply <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="MaxSupply"
                                    value={formData?.MaxSupply}
                                    onChange={onchangeFunc}
                                    placeholder="MaxSupply"
                                  />
                                  {err?.MaxSupply && <p className="text-danger mt-2">{err?.MaxSupply}</p>}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    pairAddress{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="pairAddress"
                                    value={formData?.pairAddress}
                                    onChange={onchangeFunc}
                                    placeholder="pairAddress"
                                  />
                                  {err?.pairAddress && (
                                    <p className="text-danger mt-2">{err?.pairAddress}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    Short Description{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="shortdescription"
                                    value={formData?.shortdescription}
                                    onChange={onchangeFunc}
                                    placeholder="shortdescription"
                                  />
                                  {err?.shortdescription && (
                                    <p className="text-danger mt-2">{err?.shortdescription}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <label>
                                    CirculatingSupply{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="CirculatingSupply"
                                    onChange={onchangeFunc}
                                    value={formData?.CirculatingSupply}
                                    placeholder="Symbol of the coin/token, e.g. BTC"
                                  />
                                  {err?.CirculatingSupply && (
                                    <p className="text-danger mt-2">{err?.CirculatingSupply}</p>
                                  )}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>
                                    Website URL{" "}
                                    <span className="redclr">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="blockExplorer"
                                    value={formData?.blockExplorer}
                                    onChange={onchangeFunc}
                                  />
                                  {err?.blockExplorer && (
                                    <p className="text-danger mt-2">{err?.blockExplorer}</p>
                                  )}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Git Link </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="git_link"
                                    value={formData?.git_link}
                                    onChange={onchangeFunc}
                                  />
                                  {err?.git_link && <p className="text-danger mt-2">{err?.git_link}</p>}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Twitter Link </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="Twitterlink"
                                    value={formData?.Twitterlink}
                                    onChange={onchangeFunc}
                                  />
                                  {err?.Twitterlink && (
                                    <p className="text-danger mt-2">{err?.Twitterlink}</p>
                                  )}
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <label>Whitepaper Link </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="whitpaperlink"
                                    value={formData?.whitpaperlink}
                                    onChange={onchangeFunc}
                                  />
                                  <p className="lightclr mt-1 mb-0">
                                    Please include the link to your project
                                    whitepaper
                                  </p>
                                  {err?.whitpaperlink && (
                                    <p className="text-danger mt-2">{err?.whitpaperlink}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <label>Category</label>
                                  <Dropdown
                                    className="reqdrop"
                                    onSelect={(e) => {
                                      console.log("e-->", e);
                                      onchangeFunc({
                                        target: {
                                          name: "category",
                                          value: e.split(",")[0],
                                          data: e.split(",")[1],
                                        },
                                      });
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      className="w-100 text-start"
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      {selCat == ""
                                        ? "Select Category"
                                        : selCat}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="w-100">
                                      {categorylist?.map((val) => (
                                        <Dropdown.Item
                                          onClick={() =>
                                            setSubCat(val?.subcategory)
                                          }
                                          eventKey={`${val?._id},${val.name}`}
                                        >
                                          {val?.name}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  {err?.category && <p className="text-danger mt-2">{err?.category}</p>}
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <label>Sub Category</label>
                                  <Dropdown
                                    className="reqdrop"
                                    onSelect={(e) => {
                                      console.log("e-->", e);
                                      onchangeFunc({
                                        target: {
                                          name: "subcategory",
                                          value: e.split(",")[0],
                                          data: e.split(",")[1],
                                        },
                                      });
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      className="w-100 text-start"
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      {selSubCat == ""
                                        ? "Select Sub Category"
                                        : selSubCat}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="w-100">
                                      {subCat?.map((val) => (
                                        <Dropdown.Item
                                          eventKey={`${val?._id},${val.name}`}
                                        >
                                          {val?.name}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  {err?.subcategory && (
                                    <p className="text-danger mt-2">{err?.subcategory}</p>
                                  )}
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <label>Network</label>
                                  <Dropdown
                                    className="reqdrop"
                                    onSelect={(e) => {
                                      onchangeFunc({
                                        target: {
                                          name: "network",
                                          value: e.split(",")[0],
                                          data: e.split(",")[1],
                                        },
                                      });
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      className="w-100 text-start"
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      {selNetwork == ""
                                        ? "Select Network"
                                        : selNetwork}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="w-100">
                                      {networklist?.map((val) => (
                                        <Dropdown.Item
                                          eventKey={`${val?._id},${val.name}`}
                                        >
                                          {val?.name}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  {err?.network && <p className="text-danger mt-2">{err?.network}</p>}
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr className="reqhr"></hr>
                          <div className="d-flex mt-3">
                            <button
                              className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                              onClick={() => handleNextBtton(steps + 1)}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      </>
                    )}

                    {steps == exchangeLists?.length + 5 && (
                      <>
                        <h4 className="fw-600 text-center">
                          Your Project Scoresheet
                        </h4>
                        <p className="text-center">
                          Your Project scores a total of{" "}
                          <span className="redclr">{percentage}%</span>{" "}
                        </p>
                        <Scorecard />
                        <div className="mt-3 noteclr">
                          <p className="mb-2 fw-600">Note</p>
                          <ul className="ps-3">
                            <li>
                              For Failed Project (SOC score less than 30%):
                            </li>
                            <li>
                              Sorry, you cannot list yet on EdaFace. You’ll need
                              to improve on your score to be able to list on
                              EdaFace.
                            </li>
                            <li>
                              Your Project must score at least 30% in order to
                              list on EdaFace.
                            </li>
                            <li>
                              If you want to see the full analysis of your score
                              that will show area of improvement, click
                              here….(see attached score analysis) --- see it
                              below
                            </li>
                          </ul>
                        </div>

                        <button
                          className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                          onClick={() => handleNextBtton(steps + 1)}
                        >
                          Next
                        </button>
                      </>
                    )}

                    {steps == exchangeLists?.length + 6 && (
                      <>
                        <h4 className="fw-600 text-center mb-4">
                          Project Submission Page
                        </h4>
                        <div class="form-check d-flex verifycheck mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={formsLists?.projectSubcheckOne}
                            id="flexCheckDefault"
                            onChange={(e) => {
                              setFormsLists((prev) => ({
                                ...prev,
                                projectSubcheckOne: e.target.checked,
                              }));

                              setFieldErrors((prevErrors) => ({
                                ...prevErrors,
                                projectSubcheckOne: "",
                              }));
                            }}
                          />
                          <label
                            class="form-check-label fw-400"
                            for="flexCheckDefault"
                          >
                            All the information I have provided are accurate and
                            true. Any misrepresentation may result in delisting
                            my Project and legal action.
                          </label>
                          {fieldErrors.projectSubcheckOne && (
                            <div className="text-danger">
                              {fieldErrors.projectSubcheckOne}
                            </div>
                          )}
                        </div>
                        <div class="form-check d-flex verifycheck mb-3">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            checked={formsLists?.projectSubchecktwo}
                            id="flexCheckDefault"
                            onChange={(e) => {
                              setFormsLists((prev) => ({
                                ...prev,
                                projectSubchecktwo: e.target.checked,
                              }));
                              setFieldErrors((prevErrors) => ({
                                ...prevErrors,
                                projectSubchecktwo: "",
                              }));
                              /*  */
                            }}
                          />
                          <label
                            class="form-check-label fw-400"
                            for="flexCheckDefault"
                          >
                            Since EdaFace Listing Platforms are decentralized
                            and automated, once you successfully click the
                            Submit Button, your Project will automatically
                            become live on EdaFace, and receive Prelim Verify
                            status that will be confirmed later in accordance
                            with EdaFace Compliance Grading.
                          </label>
                          {fieldErrors.projectSubchecktwo && (
                            <div className="text-danger">
                              {fieldErrors.projectSubchecktwo}
                            </div>
                          )}
                        </div>
                        <div className="mt-3 mb-3 form_list">
                          <label>A summary of all the filled 15 items</label>
                          <textarea
                            rows={4}
                            type="text"
                            className="form-control"
                            name=""
                            value={formsLists?.suggesstion}
                            onChange={(e) => {
                              setFormsLists((prev) => ({
                                ...prev,
                                suggesstion: e.target.value,
                              }));
                            }}
                          />
                        </div>
                        <div className="d-flex justify-content-between gap-3 flex-wrap pt-2">
                          <button
                            className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                            onClick={(e) => setSteps(2)}
                          >
                            Make Correction
                          </button>
                          <button
                            className="themebtn themehoverbtn rounded-1 fbtn py-3 fw-600"
                            onClick={() => handleSubmit(steps)}
                          >
                            Submit Now
                          </button>
                        </div>
                        -
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Listcointoken;
